import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import styles from './AppVersion.module.scss';
import { useSelector } from 'react-redux';
import { useEffectSkipFirst } from '../../../../hooks/useEffectSkipFirst';
import { getTranslation } from '../../../../utils/translation';
import LocalStorage, { LOCAL_STORAGE_KEYS } from '../../../../utils/localStorage';

const AppVersion = () => {
    const appVersion = useSelector(state => state.global.appVersion);

    const [toastId, setToastId] = useState();

    useEffectSkipFirst(() => {
        const currentAppVersion = LocalStorage.getItem(LOCAL_STORAGE_KEYS.appVersion);

        if (currentAppVersion !== appVersion) {
            showNewVersionToast();
        } else {
            toast.dismiss(toastId);
            setToastId(null);
        }
    }, [appVersion]);

    const showNewVersionToast = () => {
        if (toastId) {
            toast.dismiss(toastId);
        }

        const newToastId = toast.warn(
            <div className={'flex justify-between align-center'}>
                <div className={'p-2'}>
                    <FontAwesomeIcon icon={faExclamationTriangle} className={'m-r-4'} />
                    <span>{getTranslation('newVersionNotificationMessage')}</span>
                </div>
                <div className={`${styles.actionButton} p-x-3 p-y-2`} onClick={refreshPage}>
                    {getTranslation('newVersionNotificationReload')}
                </div>
            </div>,
            {
                position: 'bottom-left',
                hideProgressBar: true,
                closeButton: false,
                autoClose: false,
                closeOnClick: false,
                draggable: false,
                className: styles.appVersionToast,
                bodyClassName: 'w-full',
            }
        );

        setToastId(newToastId);
    };

    const refreshPage = () => {
        window.location.reload();
        LocalStorage.setItem(LOCAL_STORAGE_KEYS.appVersion, appVersion);
    };

    return null;
};

export default AppVersion;
